import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { TenantsService } from './core/services/tenants.service';
import { companyConfigService } from './core/services/company-config.service';
import { CurrencySettingsService } from './core/services/currency-setting.service';
import { IndexedDbService } from './core/services/indexed-dbservice.service';

declare let fbq: any;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'TravelofficeUI';
  constructor(
    private tanentser: TenantsService,
    private cookieService: CookieService,
    private companyConfigService: companyConfigService,
    private dbService: IndexedDbService,
    private currencySettings: CurrencySettingsService,
    private renderer: Renderer2,
    private router: Router
  ) {
    // Track PageView on route changes for Meta Pixel
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (typeof fbq !== 'undefined') {
        fbq('track', 'PageView');
      }
    });

    // Load the app configuration
    this.dbService.getData('userLang').then(data => {
      const dir = data === 'AR' ? 'rtl' : 'ltr';
      if (typeof document !== 'undefined') {
        this.renderer.setAttribute(document.documentElement, 'dir', dir);
        this.renderer.setAttribute(document.body, 'dir', dir);
      }
    });
  }
  ngOnInit(): void {
    // const token = this.cookieService.get('authToken');
    const CompanyId = this.tanentser.getTenantFromSubdomain();
    let currData: any;
    this.dbService.getData('userCurr').then(data => {
      currData = data;
      if (currData) {
        this.currencySettings.setCurrency(currData.TargetCurrency, currData.SellROE);
      }
    });
    // console.log(this.companyConfigService.getConfig());
  }


}
